export default __webpack_public_path__ + "static/promo-l8-img-e33ce32ff4102d379f59168475440c2d.png";